module.exports = __webpack_public_path__ + "static/media/contact.54fbbdf1.svg";